import * as R from 'ramda'

/**
 * This capitalizes that first character of the string
 * @param string
 */
export default (string = '') => {
  if (string.length > 0) {
    const [first, rest] = R.splitAt(1, string)
    return first.toUpperCase() + rest
  } else return string
}
